import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img06.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#101010" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              The Best App Developers In Florida - Functional Apps At Leanest
              Budgets
            </h2>
            <p>
              Tekrevol values your investment into an app idea and our team
              brings everything to the table to ensure that you get the kind of
              final app that can engage users sustainably when it goes live on
              the app stores.{" "}
            </p>
            <p>
              Throughout our existence as the top tier mobile development agency
              in Florida, we’ve partnered with all types of businesses, ranging
              from completely new startups to thriving multinational
              enterprises, to deliver world-class apps that are primed to
              achieve specific business objectives.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#101010",
                border: "1px solid #101010",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
